<template>
  <ChooseExperienceBanner
    :count="count"
    :href="href"
    :city="city"
    :empty-href="emptyHref"
    :pinned="pinned"
    full-width
  />
</template>

<script setup lang="ts">
import ChooseExperienceBanner from './ChooseExperienceBanner.vue';

withDefaults(
  defineProps<{
    count: number;
    href: string;
    city?: string;
    emptyHref?: string;
    /** Прилипает к низу экрана; без него баннер просто стоит в потоке. */
    pinned?: boolean;
  }>(),
  {
    city: '',
    emptyHref: '',
    pinned: false,
  },
);
</script>
